<template>
    <Modal fullscreen transfer :value="visible" footer-hide @on-visible-change="$emit('update:visible', $event)"
        class-name="modal-full" :title="form.chineseName">
        <div style="padding:20px;height: 100%">
            <Row v-if="!loading" style="height: 100%" :gutter="24">
                <Col :span="expand?2:6" style="height: 100%">
                <div style="background-color: #fff;border-radius: 12px;height: 100%;overflow:auto">
                    <div
                        style="position: sticky;top:0;left:0;right:0;font-size: 20px;font-weight: 600;padding:20px 30px;background:#fff;z-index: 1;display:flex;justify-content: space-between;align-items: center;">
                        
                            <div v-show="!expand">章节管理</div>
                            <Button style="padding: 5px 6px" @click="expand=!expand">
                                <Icon :size="20" type="ios-list" />
                            </Button>
                        </div>
                    <div style="padding: 0 30px">
                        <div v-for="(item, index) in chapterList" :key="index" :class="{
                            chapters: true,
                            selected: selectedIndex == index
                        }" @click="handleChangeSelect(index)">
                            <span>{{ item.seriesNum }}</span>
                            <span v-show="!expand" style="word-break: break-all;margin-left: 10px;
                            white-space: nowrap;
                            width: 100%;
                            overflow: hidden;
                            display: block;
                            word-break: break-word;
                            overflow: hidden;
                            display: -webkit-box;
                            -webkit-line-clamp: 2;
                            -webkit-box-orient: vertical;
                            text-overflow: ellipsis;
                            white-space: normal;">
                                {{ item.seriesName }}</span>
                        </div>
                        <div class="chapters selected" v-show="!expand" style="text-align: center;justify-content: center;" @click="chapterList.push({
                            seriesNum: Number(chapterList[chapterList.length - 1].seriesNum) + 1,
                            seriesName: 'Chapter ' + (chapterList[chapterList.length - 1].seriesNum + 1),
                            changed: true
                        })">
                            <Icon type="md-add"></Icon>
                            新增章节
                        </div>
                    </div>
                </div>
                </Col>
                <Col :span="expand?22:18" style="height: 100%">
                <div style="background-color: #fff;border-radius: 12px;height: 100%;padding:20px 30px;overflow:hidden">
                    <Form v-if="chapterList.length" :model="chapterList[selectedIndex]" label-position="top"
                        style="height: 100%;overflow:auto">

                        <div style="display: flex;justify-content: space-between;position:sticky;top:0;background:#fff;z-index:1">
                            <div style="font-size: 20px;font-weight: 600;">正文</div>
                            <div style="text-align: right;">
                                    <Button v-if="!chapterList[selectedIndex].isEdit" type="info" @click="
                                        $set(chapterList[selectedIndex],'isEdit',true);
                                        $set(chapterList[selectedIndex],'title',chapterList[selectedIndex].seriesName);
                                        $set(chapterList[selectedIndex],'originNovelContent',chapterList[selectedIndex].novelContent);
                                    ">编辑</Button>
                                    <Button v-else @click="
                                        $set(chapterList[selectedIndex],'isEdit',false);
                                        $set(chapterList[selectedIndex],'seriesName',chapterList[selectedIndex].title);
                                        $set(chapterList[selectedIndex],'novelContent',chapterList[selectedIndex].originNovelContent);
                                        $set(chapterList[selectedIndex],'changed',false);
                                    " >取消</Button>
                                    <Button v-if="selectedIndex!=0" style="margin-left: 20px;" type="warning" @click="handleChangeSelect(selectedIndex-1)">上一章</Button>
                                    <Button v-if="selectedIndex!=chapterList.length-1" style="margin-left: 20px;" type="warning" @click="handleChangeSelect(selectedIndex+1)">下一章</Button>
                                    <Button v-if="selectedIndex!=chapterList.length-1" style="margin-left: 20px;" type="success" @click="handleCopy">复制</Button>
                                    <Button style="margin-left: 20px;" @click="handleSubmit1()" :loading="submitLoading">保存当前章节</Button>
                                    <Button type="primary" style="margin-left: 20px;" @click="handleSubmit()"
                                        :disabled="this.chapterList.filter(i => i.changed).length == 0"
                                        :loading="submitLoading">保存全部</Button>
                            </div>
                        </div>
                        <FormItem label="章节标题" style="margin-top: 20px;">
                            <div v-if="!chapterList[selectedIndex].isEdit">{{ chapterList[selectedIndex].seriesName }}</div>
                            <Input v-else v-model="chapterList[selectedIndex].seriesName" :maxlength="1000"
                                @on-change="chapterList[selectedIndex].changed = true" />
                        </FormItem>
                        <FormItem label="正文内容">
                            <div v-if="!chapterList[selectedIndex].isEdit" v-html="chapterList[selectedIndex].novelContent?chapterList[selectedIndex].novelContent.replaceAll('\n','<br>'):''">
                            </div>
                            <Input v-else type="textarea" autosize style="height: 100%;"
                                v-model="chapterList[selectedIndex].novelContent"
                                @on-change="chapterList[selectedIndex].changed = true" />
                        </FormItem>
                        <FormItem>

                        </FormItem>
                    </Form>
                </div>
                </Col>
            </Row>
            <Spin v-else fix>加载中...</Spin>
        </div>
    </Modal>
</template>

<script>
import { getNovelDetail, saveNovelChapters } from '@/api/novel'
import { copyText } from '../../libs/util';
export default {
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        form: {
            type: Object,
            default: () => ({})
        },
    },
    model: {
        prop: 'visible',
        event: 'update:visible'
    },
    data() {
        return {
            expand: false,
            chapterList: [],
            selectedIndex: 0,
            loading: false,
            submitLoading: false,
            modalForm: {},
        }
    },
    watch: {
        visible: {
            handler() {
                if (this.visible && this.form.id) {
                    this.handleGetData()
                }
            }
        }
    },
    methods: {
        handleSubmit1() {
            this.submitLoading = true
            saveNovelChapters({
                novelId: this.form.id,
                novelList: [{
                    chapterId: this.chapterList[this.selectedIndex].id,
                    chapterContent: this.chapterList[this.selectedIndex].novelContent,
                    chapterName: this.chapterList[this.selectedIndex].seriesName,
                    chapterNum: this.chapterList[this.selectedIndex].seriesNum
                }]
            }).then(r => {
                this.chapterList[this.selectedIndex].changed = false
                this.handleGetData(this.selectedIndex)
                this.$Message.success(this.chapterList[this.selectedIndex].id ? '编辑成功' : '添加成功')
            }).catch(e => {
                this.$Message.error(this.chapterList[this.selectedIndex].id ? '编辑失败' : '添加失败')

            }).finally(() => {
                this.submitLoading = false
            })
        },
        handleSubmit() {
            if (this.chapterList.filter(i => i.changed).length == 0) return
            this.submitLoading = true
            saveNovelChapters({
                novelId: this.form.id,
                novelList: this.chapterList.filter(i => i.changed).map(i => ({
                    chapterId: i.id,
                    chapterContent: i.novelContent,
                    chapterName: i.seriesName,
                    chapterNum: i.seriesNum
                }))
            }).then(r => {
                this.handleGetData(this.selectedIndex)

                this.$Message.success('操作成功')
            }).catch(e => {
                this.$Message.error('操作失败')

            }).finally(() => {
                this.submitLoading = false
            })
        },
        handleCopy(){
            copyText(this.chapterList[this.selectedIndex].novelContent)
        },
        handleGetData(id) {
            this.loading = true
            getNovelDetail(this.form.id).then(r => {
                const detail = r.data || {}
                const chapters = Array.isArray(detail.chapters) ? detail.chapters : []
                this.chapterList = chapters.map(item => ({
                    ...item,
                    seriesNum: item.chapterNum,
                    seriesName: item.chapterName,
                    changed: false,
                    isEdit: false
                }))
                if (this.chapterList.length) {
                    const nextIndex = typeof id === 'number' && id < this.chapterList.length ? id : 0
                    this.handleChangeSelect(nextIndex)
                }
            }).finally(() => {
                this.loading = false
            })
        },
        async handleChangeSelect(row) {
            this.selectedIndex = typeof row === 'number' ? row : 0
            const data = this.chapterList[this.selectedIndex]
            if (!data) return
            if (data.fileUrl) {
                const response = await fetch(data.fileUrl);
                const text = await response.text()
                this.$set(this.chapterList[this.selectedIndex], 'novelContent', text)
            } else {
                this.$set(this.chapterList[this.selectedIndex], 'novelContent', '')
            }


        }
    }
}
</script>

<style lang="less" scoped>
/deep/.modal-full {
    z-index: 1500 !important;
    background-color: #f6f7f8;

    .ivu-modal-body {
        background-color: #f6f7f8;
    }
}

.chapters {
    padding: 7px 20px;
    margin-bottom: 20px;
    border-radius: 10px;
    font-size: 18px;
    font-weight: 500;
    cursor: pointer;
    display: flex;
    align-items: center;
    background-color: #eeeeee66;

}

.selected {
    background-color: #e7f2fd;
    color: #127eec;
}
</style>
